import React from "react";
import Image from "next/image";
import { Container } from "react-bootstrap";
import NavBar from "../../NavBar";
import { Background, BgNav, Content } from "./styles";

const BusinessBanner = () => {
    return (
        <Background>
            <BgNav>
                <NavBar />
            </BgNav>

            <Container>
                <Content>
                    <div>
                        <h1>Nós gerenciamos a sua operação de fotos para que você foque no seu negócio</h1>
                        <p>Fotos profissionais para todas as necessidades da sua empresa</p>

                        <a target="_blank" href="https://servicos.fotop.com.br/book">
                            SOLICITE JÁ
                        </a>
                    </div>

                    <a href="#information">
                        <Image src="/images/arrow-down.png" alt="seta para baixo" width={30} height={22} />
                    </a>
                </Content>
            </Container>
        </Background>
    );
};

export default BusinessBanner;
